import React, { Component } from 'react'
import { Layout, Button, Row, Col, Tabs, Icon, Divider } from 'antd';
import style from './Login.css';
import logo from '../login/200x35蒙牛.png'
import codeImg from './code.png'
import RegisterForm from './RegisterForm'

const { Header, Footer, Content } = Layout;
export default class index extends Component {
  render() {
    return (
      <Layout className={style.loginLayout}>
          <Header className={style.loginHeader}>
              <div className={style.loginTitle}>
                  <img className={style.loginTitleImg}
                      src={logo}
                      alt="" />
              </div>
              {/* <div className={style.divider}></div>
              <div className={style.loginTitleText}>
                  创新中粮供应链金融模式 <br/>
                  打造农业产业金融生态圈
              </div> */}
              <div onClick={() => { tool.popSingleUI('/') }} className={style.toLogin}>
                已有账号，立即登录
              </div>
          </Header>
          <Content className={style.loginContent}>
            <h2 className={style.formTitle} style={{color: '#00b34f'}}>用户注册</h2>
            <Divider className={style.Divider1} />
            <RegisterForm formstate="asdasd"></RegisterForm>
          </Content>
          {/* <Footer className={style.loginFooter}>
              <div className={style.Footer_content}>
                  <img src={codeImg}></img>
                  <a href={'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010102001167'} target="_blank">津公网安备12010102001167号</a>
                  <a href={'https://beian.miit.gov.cn/#/Integrated/index'} target="_blank">津ICP备2023004811号-7</a> 
              </div>
          </Footer> */}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/register/index.js